<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <RolesTable
          ref="rolesTable"
          :account-id="accountId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import RolesTable from '@/components/Application/Manage/Account/RolesTable'

export default {
  components: {
    RolesTable
  },
  data () {
    return {
      accountId: this.$route.params.accountId,
      breadcrumb: {
        name: 'Roles',
        route: { name: 'manage-accounts-account-configurations-roles', params: { accountId: this.$route.params.accountId } }
      }
    }
  },
  mounted () {
    this.actions = this.$refs.rolesTable.actions
  }
}
</script>

<style>

</style>
